'use client';

import './styles/@theme';

import { Fragment } from 'react';
import { getText } from '@/utils/text/text';
import { AnimatedTopBar } from '../animated-top-bar/animated-top-bar';
import { classes } from '@/utils/classes/classes';
import { SvgLoader } from '@/app/elements/svg/loader';
import type { MultiplierFormat } from '@/app/components/site-wide-jackpot/transformers/site-wide-jackpot.transformer';

type OptInMultiplierProps = {
    scrolledView: boolean;
    multiplier: number;
    multipliers?: MultiplierFormat[];
    wageredAmount: number;
    shortWagerLabel?: string;
    handleOptOut: () => void;
};

type StaticMultiplierProps = {
    wageredAmount: number;
    boosted: boolean;
    shortWagerLabel?: string;
};

const StaticMultiplier = ({ wageredAmount, boosted, shortWagerLabel }: StaticMultiplierProps) => (
    <>
        <div className="multiplier-checkmark">
            <SvgLoader iconName="site-wide-jackpot-checkmark" directory="swj-icons" />
        </div>
        <div className="multiplier-text">
            <span className="multiplier-text-state">
                {getText({ text: 'components.siteWideJackpots.optedInStatus' })}
            </span>
            <span className="multiplier-text-amount">
                ${wageredAmount.toFixed(2)}
                {boosted && (
                    <span className="multiplier-text-boosted">
                        <span className="multiplier-text-boosted-label">{shortWagerLabel}</span>
                        <SvgLoader
                            iconName="site-wide-jackpot-bolt"
                            directory="swj-icons"
                            fill="purple"
                            width={7}
                            height={10}
                        />
                    </span>
                )}
            </span>
        </div>
    </>
);

export const OptInMultiplier = ({
    wageredAmount,
    multipliers,
    multiplier,
    shortWagerLabel,
    handleOptOut,
    scrolledView
}: OptInMultiplierProps) => {
    const boosted = multiplier > 1;

    return (
        <div
            className={classes('multiplier', boosted && 'boosted')}
            role="none"
            onClick={() => handleOptOut()}
            onKeyDown={() => handleOptOut()}>
            {!boosted && <div className="multiplier-white-border"></div>}
            {boosted && <SvgLoader iconName="site-wide-jackpot-glow-border" directory="swj-icons" />}
            {!scrolledView ? (
                <StaticMultiplier wageredAmount={wageredAmount} boosted={boosted} shortWagerLabel={shortWagerLabel} />
            ) : (
                <AnimatedTopBar
                    wageredAmount={wageredAmount}
                    boosted={boosted}
                    shortWagerLabel={shortWagerLabel}
                    multiplier={multiplier}
                    multipliers={multipliers}
                />
            )}
            <div className="multiplier-opt-out">{getText({ text: 'components.siteWideJackpots.ctaOptOut' })}</div>
        </div>
    );
};
